import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GATrackingEventType } from '../../constants';

export class GaTrackingZRPOtherBucketsClickedEventModel implements GATrackingEvent {
  constructor(private payload: { action: GATrackingEventType; element: string }) {}

  getEventActionFromPage(): any {
    return `${this.payload.action} clicked`;
  }

  getEventType(): GATrackingEventType {
    return this.getEventActionFromPage();
  }

  getPayload(): GATrackingEventPayload {
    return {
      event: 'bucket_clicked',
      label: this.payload.element,
    };
  }
}
